/**
 * Sticky Add-to-Cart Manager
 * Handles scroll-based visibility for sticky add-to-cart elements
 */

// Prevent duplicate class declarations
if (typeof window.StickyCartManager === 'undefined') {

  window.StickyCartManager = class StickyCartManager {

    constructor() {
      this._observer = null;
      this._mounted = false;
      this.mount();
    }

    mount() {
      if (this._mounted) return;
      this._mounted = true;

      const sticky = document.querySelector('.sticky-add-to-cart');
      const trigger = document.querySelector('.product__custom-add-to-cart.main');
      if (!sticky || !trigger) return;

      const setVisible = (isVisible) => {
        sticky.classList.toggle('sticky-cart-visible', Boolean(isVisible));
      };

      // Hide sticky when main ATC is visible; show when it's out of view.
      const updateFromEntry = (entry) => {
        if (!entry) return;
        if (entry.isIntersecting) {
          setVisible(false);
          return;
        }

        // Only show after the main ATC has been scrolled past (i.e. it's above viewport),
        // not when it's simply below the fold.
        const isAboveViewport = (entry.boundingClientRect?.top ?? 1) < 0;
        setVisible(isAboveViewport);
      };

      // Disconnect any previous observer.
      try {
        this._observer?.disconnect?.();
      } catch (_) {}

      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(
          (entries) => {
            updateFromEntry(entries && entries[0]);
          },
          {
            // Consider it "visible" only when a decent portion is in view.
            threshold: [0, 0.15],
          }
        );
        this._observer.observe(trigger);
      } else {
        // Fallback: simple scroll check
        const onScroll = () => {
          const r = trigger.getBoundingClientRect();
          const inView = r.bottom > 0 && r.top < window.innerHeight;
          if (inView) {
            setVisible(false);
            return;
          }
          setVisible(r.bottom < 0);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }
    }
  };

  // Initialize the sticky cart manager (safe: it no-ops if elements not present)
  window.stickyCartManager = window.stickyCartManager || new window.StickyCartManager();
}